import {ChartIQThemeHelperConstructor} from "./ChartIQTheme";
import {ChartIQEngine, ChartIQEngineInstance} from "./ChartIQEngine";
import {ChartIQStudies} from "./ChartIQStudies";
import {Equality, StringKeyed} from "../../../types/GenericTypes";
import {ChartIQI18N} from "./ChartIQI18N";

declare global {
    interface Window {
        readonly CIQ: ChartIQ;
    }
}

export interface ChartIQ {
    readonly touchDevice: boolean;
    readonly ChartEngine: ChartIQEngine;
    readonly Drawing: ChartIQDrawing;
    readonly Studies: ChartIQStudies;
    readonly ThemeHelper: ChartIQThemeHelperConstructor;
    readonly I18N: ChartIQI18N;
    shallowClone<T>(object: T): T;
    translatableTextNode(stx: ChartIQEngineInstance, english: string, language?: string): HTMLElement;
}

export type ChartIQDrawingTool = Function | string;

export type ChartIQVectorParameter = "currentColor" |
    "fillColor" |
    "lineWidth" |
    "pattern" |
    "axisLabel" |
    "fontSize" |
    "fontStyle" |
    "fontWeight" |
    "fontFamily";

export type ChartIQVectorParameterValue = string | number | boolean;

export type ChartIQInterval = "day" | "week" | "month" | "tick" | number;
export type ChartIQTimeUnit = "millisecond" | "second" | "minute";

export interface ChartIQPeriodicity {
    period?: number;
    interval?: ChartIQInterval;
    timeUnit: ChartIQTimeUnit | null;
}

export function chartIqPeriodicityEquality(): Equality<ChartIQPeriodicity> {
    return (a, b) => (a.period === b.period) && (a.interval === b.interval) && (a.timeUnit === b.timeUnit);
}

export interface ChartIQSerializedLayout {
    interval: number;
    periodicity: number;
    timeUnit: string;
    candleWidth: number;
    volumeUnderlay: boolean;
    adj: boolean;
    crosshair: boolean;
    chartType: string;
    extended: boolean;
    marketSessions: MarketSessions;
    aggregationType: string;
    chartScale: string;
    panels: Panels;
    setSpan: MarketSessions;
    range: MarketSessions;
    studies: Studies;
}

export interface ChartIQLayoutImportParams {
    managePeriodicity?: boolean;
    preserveTicksAndCandleWidth?: boolean;
    noDataLoad?: boolean;
}

export type ChartIQSerializedDrawings = any;

export interface ChartIQDrawing extends StringKeyed<ChartIQDrawingTool> {
    getDrawingToolList(exclude: StringKeyed<boolean>): StringKeyed<ChartIQDrawingTool>;
}

export interface MarketSessions {
}

export interface Panels {
    chart: Chart;
}

export interface Chart {
    percent: number;
    display: string;
    chartName: string;
    top: number;
}

export interface Studies {
    studyName: StudyConfig;
}

export interface StudyConfig {
    type: string;
    inputs: Inputs;
    outputs: Outputs;
    panel: string;
    parameters: Parameters;
}

export interface Inputs {
    id: string;
    display: string;
}

export interface Outputs {
    IV30: string;
}

export interface Parameters {
    chartName: string;
    editMode: boolean;
}
